import { z } from 'zod';

export enum ValidationDepth {
    CHANGED_PROPERTY_ONLY = 'CHANGED_PROPERTY_ONLY',
    FULL = 'FULL',
}

export const ValidationDepthSchema = z.enum(ValidationDepth);
